import React from "react";

/**
 * BrandLogo — uses the official OpenPayments spiral PNG (transparent background)
 * + an "OpenPayments" wordmark in solid dark navy. Same asset is embedded in
 * receipt/certificate PDFs by the backend.
 *
 * Props:
 *   size      — icon side in px (default 32)
 *   wordmark  — show "OpenPayments" text next to icon (default true)
 *   tone      — "dark" (default, navy text for white backgrounds)
 *               | "light" (white text for dark backgrounds)
 */
export default function BrandLogo({ size = 32, wordmark = true, tone = "dark", className = "" }) {
  const textColor = tone === "light" ? "#FFFFFF" : "#0A1A3F";
  return (
    <span className={`inline-flex items-center gap-2.5 align-middle ${className}`} data-testid="brand-logo">
      <img
        src="/brand/openpayments-logo.png"
        alt="OpenPayments"
        width={size}
        height={size}
        style={{ width: size, height: size, objectFit: "contain", display: "block", flexShrink: 0 }}
      />
      {wordmark && (
        <span
          className="font-display font-extrabold tracking-tight whitespace-nowrap select-none"
          style={{
            fontSize: Math.max(15, size * 0.62),
            lineHeight: 1,
            color: textColor,
            letterSpacing: "-0.02em",
          }}
        >
          OpenPayments
        </span>
      )}
    </span>
  );
}
